import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SubscriptionStatus } from '@hero/schema';
import { Badge } from '../../../ui/Badge/Badge';

export interface SubscriptionStatusBadgeProps {
  status: SubscriptionStatus;
}

/**
 * Pure status pill for `Subscription.status`. Colours are scoped here so
 * the carrier dashboard and admin panel render the same chip.
 */
export function SubscriptionStatusBadge({ status }: SubscriptionStatusBadgeProps) {
  const { t } = useTranslation('m-billing');
  return (
    <Badge variant="secondary" size="small" className={statusClasses[status]}>
      {t(`subscription.status.${status}`)}
    </Badge>
  );
}

const statusClasses: Record<SubscriptionStatus, string> = {
  trialing: 'bg-blue-100 text-blue-800',
  active: 'bg-green-100 text-green-800',
  past_due: 'bg-red-100 text-red-800',
  canceled: 'bg-gray-200 text-gray-800',
  paused: 'bg-yellow-100 text-yellow-800',
};
